/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';
import type { TeamSizeResource } from './';
import {
    TeamSizeResourceFromJSON,
    TeamSizeResourceFromJSONTyped,
    TeamSizeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientTeamProfileUpdateRequest
 */
export interface ClientTeamProfileUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientTeamProfileUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {TeamSizeResource}
     * @memberof ClientTeamProfileUpdateRequest
     */
    size?: TeamSizeResource;
    /**
     * 
     * @type {ActivityArea}
     * @memberof ClientTeamProfileUpdateRequest
     */
    activityArea?: ActivityArea;
    /**
     * 
     * @type {string}
     * @memberof ClientTeamProfileUpdateRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the ClientTeamProfileUpdateRequest interface.
 */
export function instanceOfClientTeamProfileUpdateRequest(value: object): value is ClientTeamProfileUpdateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ClientTeamProfileUpdateRequestFromJSON(json: any): ClientTeamProfileUpdateRequest {
    return ClientTeamProfileUpdateRequestFromJSONTyped(json, false);
}

export function ClientTeamProfileUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientTeamProfileUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'size': json['size'] == null ? undefined : TeamSizeResourceFromJSON(json['size']),
        'activityArea': json['activityArea'] == null ? undefined : ActivityAreaFromJSON(json['activityArea']),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ClientTeamProfileUpdateRequestToJSON(value?: ClientTeamProfileUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'size': TeamSizeResourceToJSON(value['size']),
        'activityArea': ActivityAreaToJSON(value['activityArea']),
        'description': value['description'],
    };
}

